import { useMemo } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { campaignKeys } from '../queryKeys';
import { campaignCopy, errorMessage } from '../../copy';
import { createRosterMutationsApi } from '../api/rosterMutations';

type KeepVars = { entryId: string };

/** Restores the product set a rollback set aside. Any outcome refetches: a
 *  conflict means the row changed underneath, and the refetch drops the prompt. */
export function useKeepPreviousProducts(campaignId: string) {
  const queryClient = useQueryClient();
  const api = useMemo(() => createRosterMutationsApi(), []);

  return useMutation<void, Error, KeepVars>({
    mutationFn: ({ entryId }) => api.keepPreviousProducts(entryId),
    onError: (err) => {
      toast.error(errorMessage(err, campaignCopy.creator.previousProducts.keepError));
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: campaignKeys.rosterAll(campaignId) });
    },
  });
}
